import type { ZapierContainerComponent } from './zapier-container.component';

export type ZapierContainerComponentT = new (...args: any[]) => ZapierContainerComponent;

export const ZapierComponentLoader: () => Promise<ZapierContainerComponentT> = () =>
  import('./zapier-container.component').then(k => k.ZapierContainerComponent);
